import { useApp } from '@/hooks/use-app-context';

export function ComplaintsHeader() {
  const { t } = useApp();

  return (
    <header className="relative py-8">
      <div className="grid gap-6 lg:grid-cols-[minmax(0,1fr)_minmax(300px,420px)] lg:items-end">
        <div>
          <p className="flex items-center gap-3 text-[0.68rem] font-semibold uppercase tracking-[0.28em] text-primary/70">
            {t.complaints}
          </p>
          <h1 className="mt-4 font-semibold tracking-tight text-foreground text-3xl sm:text-4xl">
            {t.complaints}
          </h1>
          <p className="mt-4 max-w-3xl text-sm leading-7 text-muted-foreground/80 sm:text-base">
            {t.complaintsMessagePlaceholder}
          </p>
        </div>

        <div className="grid grid-cols-2 gap-0 overflow-hidden rounded-2xl border border-border/40 bg-background/60">
          <Signal label={t.complaintsBug} value={t.complaintsType} />
          <Signal label={t.complaintsSuggestion} value={t.complaintsType} />
        </div>
      </div>
    </header>
  );
}

function Signal({ label, value }: { label: string; value: string }) {
  return (
    <div className="min-w-0 border-r border-border/30 px-4 py-3 last:border-r-0">
      <span className="block text-[0.6rem] font-semibold uppercase tracking-[0.2em] text-muted-foreground/50">{label}</span>
      <span className="mt-1 block truncate text-sm font-semibold text-foreground">{value}</span>
    </div>
  );
}
